<template>
  <div v-if="tipoRol === 2 || tipoRol === 6">
    <v-container>
      <v-row>
        <v-breadcrumbs :items="bread" large></v-breadcrumbs>
      </v-row>
      <div>
        <h1>Importar Legajos</h1>
      </div>
      <v-row>
        <v-col>
          Subir archivo XLXS
          <div v-if="!archivo || !isValidFile">
            Selecciona un archivo .xlsx para importar
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="8">
          <input
            label="Archivo"
            type="file"
            accept=".xlsx"
            ref="fileInput"
            @change="handleFileSelected"
          />
        </v-col>
        <v-col cols="4">
          <v-btn
            @click="uploadFile"
            color="primary"
            :disabled="!archivo || !isValidFile"
            :loading="loadingCarga"
            >Importar</v-btn
          >
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-card>
            <v-simple-table dense fixed-header class="justify-center">
              <thead>
                <tr class="justify-center">
                  <th
                    v-for="(header, index) in Object.keys(data[0] || [])"
                    :key="index"
                    class="text-h6 font-weight-bold text-center"
                  >
                    {{ header }}
                  </th>

                  <th
                    v-if="data && data.length > 0 && isEdit"
                    class="text-h6 font-weight-bold text-center"
                  >
                    Editar
                  </th>
                  <th
                    v-if="data && data.length > 0 && isEdit"
                    class="text-h6 font-weight-bold text-center"
                  >
                    Registrar
                    <v-checkbox
                      v-model="selectAllBox"
                      label="Seleccionar Todos"
                      @change="selectAllCheckboxes"
                      class="ma-2"
                      v-if="data && data.length > 0 && isEdit"
                    ></v-checkbox>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in data"
                  :key="index"
                  :class="getClass(item)"
                  class="justify-center"
                >
                  <td
                    v-for="(value, key) in item"
                    :key="key"
                    class="text-center"
                  >
                    {{ value }}
                  </td>
                  <td
                    @click="
                      showEditModal(index);
                      isValidaData = false;
                    "
                    v-if="data && data.length > 0 && isEdit"
                    class="text-center"
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </td>
                  <td
                    v-if="data && data.length > 0 && isEdit"
                    class="text-center"
                  >
                    <v-checkbox
                      v-model="checkboxStates[index]"
                      :input-value="checkboxStates[index]"
                    />
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              :disabled="isLoading"
              text
              @click="limpiarTabla"
            >
              <span v-if="!isLoading">Limpiar</span></v-btn
            >
            <v-progress-circular
              v-if="isLoading"
              :size="25"
              color="primary"
              indeterminate
            ></v-progress-circular>
            <v-btn
              color="primary"
              v-if="data && data.length > 0"
              :disabled="!isValidaData || isLoading"
              text
              @click="importar"
            >
              <span v-if="!isLoading">Importar</span>
            </v-btn>
            <v-progress-circular
              v-if="isLoading"
              :size="25"
              color="primary"
              indeterminate
            ></v-progress-circular>
            <v-btn
              color="success"
              @click="procesar"
              text
              :disabled="!data || data.length === 0"
            >
              <span v-if="!isLoading">Procesar</span></v-btn
            >
            <v-progress-circular
              v-if="isLoading"
              :size="25"
              color="primary"
              indeterminate
            ></v-progress-circular>
            <v-btn
              color="success"
              v-if="data && data.length > 0"
              @click="showExportDialog"
              text
              :disabled="!data || data.length === 0"
              ><span v-if="!isLoading">Exportar</span></v-btn
            >
            <v-progress-circular
              v-if="isLoading"
              :size="25"
              color="primary"
              indeterminate
            ></v-progress-circular>
          </v-card-actions>
        </v-col>
      </v-row>
      <ModalImportarLegajo :localidades="localidades" :data="editData" :isOpen.sync="isOpen" />
    </v-container>
  </div>
  <div v-else>
    <v-alert type="error"
      >Usted no tiene permisos para acceder a esta sección.</v-alert
    >
  </div>
</template>

<script>
import axios from 'axios';
import { API_URL } from '@/common/config';
import xlsx from 'xlsx';
import JsPDF from 'jspdf';
import 'jspdf-autotable';
import ModalImportarLegajo from '@/components/ModalImportarLegajo.vue';
import {
  isValidCBU,
  isValidCUIT,
  isValidLocalidad,
  isValidEmail,
  isValidEstadoLegajo,
  isValidFechas,
  isValidFechasDesembolso,
  isValidGarantia,
  isValidPagos,
  isValidSectorProductivo,
  isValidTipo,
} from '../common/validImport';
import moment from 'moment';
import { showSimpleMessage } from '../common/util';
import logo from '@/common/logo';
import {
  normalizeCuit,
  resumenCuitsEnFilas,
  resolverClientePorCuit,
} from '@/utils/importarLegajosCuit';

export default {
  components: {
    ModalImportarLegajo,
  },
  data() {
    return {
      tipoRol: null,
      isLoading: false,
      isProccess: false,
      isOperador: false,
      isEdit: true,
      resultadoImportacion: [],
      estadosSolicitud: null,
      operatorias: null,
      localidades:  [],
      isValidaData: false,
      selectAllBox: false,
      table: {
        headers: [],
        data: [],
      },
      errors: [],
      loadingCarga: false,
      archivo: null,
      token: localStorage.getItem('token'),
      success: false,
      successMensaje: '',
      isOpen: false,
      checkboxStates: [],
      data: [],
      editData: {},
      isValidFile: false,
      excel: [],
      bread: [
        {
          text: 'Mendoza Fiduciaria',
          disabled: false,
          href: '/',
        },
        {
          text: 'Legajos',
          disabled: true,
          href: '/',
        },
        {
          text: 'Importar Legajos',
          disabled: true,
          href: '/',
        },
      ],
      importErrors: [],
    };
  },
  name: 'ImportarLegajo',
  methods: {
    escapeHtml(value) {
      return String(value == null ? '' : value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    },
    formatCurrency(value) {
      const numericValue = parseFloat(value);
      if (isNaN(numericValue)) {
        return value;
      }
      const formatter = new Intl.NumberFormat('es-AR', {
        style: 'currency',
        currency: 'ARS',
      });

      return formatter.format(numericValue);
    },
    showExportDialog() {
      this.$swal
        .fire({
          title: 'Selecciona el formato de exportación',
          html: '<p>¡Exportar!</p>',
          showDenyButton: true,
          confirmButtonText: 'PDF',
          denyButtonText: 'Excel',
          allowOutsideClick: false,
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.exportTo(0);
          } else if (result.isDenied) {
            this.exportTo(1);
          }
        });
    },
    exportTo(tipo) {
      const doc = new JsPDF('l', 'mm', [297, 410]);
      const columnsHands = Object.keys(this.data[0]).map((el) => {
        const title = el
          .replace('nro', 'Nº')
          .replace('_', ' ')
          .replace(/(^\w|\s\w)/g, (l) => l.toUpperCase());
        return { title, dataKey: el };
      });
      const height = 50;
      const imgData = logo;
      const columnStyles = {
        text: {},
        padding: [2],
        fontSize: 10,
        columnWidth: 'auto',
      };
      doc.addImage(imgData, 'PNG', 10, 5, 48, 20);
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(18);
      doc.text('Informe Comprobantes', 15, 30);
      doc.setFontSize(13);
      doc.text(`Fecha: ${moment().format('DD/MM/YYYY')}`, 150, 30);
      doc.setFontSize(15);
      doc.text(`Periodo: ${moment().format('DD/MM/YYYY')}`, 15, 40);
      doc.autoTable(columnsHands, this.data, {
        startY: height,
        columnStyles,
      });

      if (tipo === 0) {
        doc.save(`Importacion legajos:${moment().format('DD/MM/YYYY')}.pdf`);
      }
      if (tipo === 1) {
        const informes = this.data.map((el) => {
          const row = columnsHands.reduce((acc, e) => {
            acc[e.title] = el[e.dataKey];
            return acc;
          }, {});
          return row;
        });
        const ws = xlsx.utils.json_to_sheet(informes);
        const wb = xlsx.utils.book_new();
        xlsx.utils.book_append_sheet(wb, ws, 'People');
        xlsx.writeFile(
          wb,
          `Importacion legajos:${moment().format('DD/MM/YYYY')}.xlsx`
        );
      }
    },
    selectAllCheckboxes() {
      if (this.selectAllBox) {
        this.data.forEach((t, i) => {
          this.checkboxStates[i] = true;
        });
      } else {
        this.data.forEach((t, i) => {
          this.checkboxStates[i] = false;
        });
      }
    },
    generarUsuario(item) {
      let usuarioGenerado = '';

  
      if (item.RazonSocial) {
        usuarioGenerado += item.RazonSocial.toLowerCase().replace(/\s/g, '');
      }
      if (item.Nombre) {
        usuarioGenerado += item.Nombre.substring(0, 1)
          .toLowerCase()
          .replace(/\s/g, '');
      }
      if (item.Apellido) {
        usuarioGenerado += item.Apellido.toLowerCase().replace(/\s/g, '');
      }

      if (item.CUIT && usuarioGenerado.length <= 9) {
        const cuitString = item.CUIT.toString(); // Convert to string here
        const ultimosDigitos = cuitString.replace(/\D/g, '').slice(-4);
        usuarioGenerado += ultimosDigitos;
      }

      while (usuarioGenerado.length < 9) {
        usuarioGenerado += Math.floor(Math.random() * 10);
      }
      usuarioGenerado += 'sys'; // Agrega 'sys' al final para indicar usuario creado por el sistema

      // Elimina las letras con tildes
      usuarioGenerado = usuarioGenerado
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');

      return usuarioGenerado.toLowerCase().replace(/[\s.,]/g, '');
    },
    mostrarResultadosImportacion() {
      const totalLegajos = this.resultadoImportacion.length;
      const totalOk = this.resultadoImportacion.filter(
        (res) => res.estatus === 'Success'
      ).length;

      let html =
        `
    <div style="max-width: 600px;">
      <h2>Resultados de la Importación</h2>
      <p>Total de Legajos Importados OK: ` +
        totalOk +
        ` de un total de : ` +
        totalLegajos +
        `</p>
    </br>
      <ul style="list-style-type: disc; padding-left: 20px;">
  `;
      this.resultadoImportacion.forEach((cliente) => {
        html += `
      <li>
        <strong>${cliente.Nombre} ${cliente.Apellido} - CUIT: ${cliente.CUIT}</strong><br>
        Legajo: ${cliente.legajo} - Estatus: ${cliente.estatus}
      </li>
    `;
      });
      html += `
      </ul>
    </div>
  `;
      return this.$swal.fire({
        title: '',
        html: html,
        showCloseButton: true,
        showConfirmButton: false,
        width: 'auto',
        customClass: {
          modal: 'swal-modal',
        },
      });
    },
    async updateUsuario(userId, newEmail) {
      try {
        const body = { email: newEmail };
        const respuesta = await axios.put(
          `${API_URL}api/v1/auth/${userId}`,
          body,
          {
            headers: { 'Content-Type': 'application/json', token: this.token },
          }
        );
        if (respuesta.data && respuesta.data.status === 'succes') {
          console.log('updateUsuario', respuesta.data.message);
        }
      } catch (error) {
        console.error('Error al actualizar usuario:', error);
        return null;
      }
    },
    formatValue(cliente, oper) {
      let periodicidad = 0;
      if (cliente.Pagos && oper.valor === 'Pagos') {
        switch (cliente[oper.valor]) {
          case 'Mensual':
            periodicidad = 1;
            break;
          case 'Bimestral':
            periodicidad = 2;
            break;
          case 'Trimestral':
            periodicidad = 3;
            break;
          case 'Semestral':
            periodicidad = 6;
            break;
          case 'Anual':
            periodicidad = 12;
            break;
        }

        return String(periodicidad);
      }
      if (cliente.Garantia && oper.valor === 'Garantia') {
        // La planilla puede traer la garantía en cualquier capitalización.
        const codigosGarantia = {
          pagaré: 1,
          fianza: 2,
          personal: 3,
          hipotecaria: 4,
          prenda: 5,
          'cuyo aval': 6,
        };
        const claveGarantia = String(cliente[oper.valor] || '')
          .trim()
          .toLowerCase();

        return String(codigosGarantia[claveGarantia] || 0);
      }

      if (oper.type === 'currency') {
        let parseMonto = cliente[oper.valor].replace(/[^\d]/g, '');

        // Convierte a número y divide por 100 si es necesario.
        let num = parseInt(parseMonto, 10);

        //Manejo de posibles errores de parseo
        if (isNaN(num)) {
          console.error('Error al parsear el número: ', monto);
          return monto;
        }

        return (num / 100).toFixed(2).toString();
      }
      if (oper.type === 'date') {
        return String(cliente[oper.valor]);
      }
      return String(cliente[oper.valor]);
    },
    async registrarParametros(cliente, lineaCreditoId) {
      const paramsOper = this.isOperador
        ? [
            {
              clave: 'liquidacion_aprobada',
              valor: 'InversionAprobada',
              type: 'currency',
            },
            {
              clave: 'monto_desembolso',
              valor: 'MontoANRAprobado',
              type: 'currency',
            },
            { clave: 'numero_ticket', valor: 'Ticket', type: 'string' },
          ]
        : [
            { clave: 'garantia', valor: 'Garantia', type: 'string' },
            { clave: 'monto', valor: 'MontoDelCredito', type: 'currency' },
            { clave: 'fecha_inicio', valor: 'FechaDeInicio', type: 'date' },
            { clave: 'plazo_credito', valor: 'PlazoDeCredito', type: 'date' },
            { clave: 'periodo_gracia', valor: 'PlazoDeGracia', type: 'string' },
            { clave: 'periodicidad_pagos', valor: 'Pagos', type: 'string' },
          ];

      const createParam = async (oper) => {
        try {
          const tipoParametro = await this.getTipoParametro(oper.clave); //Función auxiliar (ver más abajo)
          if (!tipoParametro) {
            console.error(`Tipo de parámetro no encontrado para ${oper.clave}`);
            return null;
          }

          const valor = this.formatValue(cliente, oper);

          const body = {
            valor: valor || '',
            lineaCreditoCliente_id: lineaCreditoId,
            tipo_parametro_id: tipoParametro.id,
          };
          if (
            Object.values(body).every(
              (value) => value === null || value === '' || value === undefined
            )
          ) {
            console.warn(
              `El objeto body está vacío o contiene solo valores nulos para ${oper.clave}. No se creará el parámetro.`
            );
            return null;
          }
          const response = await this.createClienteParametro(body); //Función auxiliar (ver más abajo)
          if (!response) {
            console.error(`Error creando parámetro: ${JSON.stringify(body)}`);
            return null;
          }
          return body;
        } catch (error) {
          console.error(`Error procesando parámetro ${oper.clave}:`, error);
          return null;
        }
      };

      const paramsPromises = paramsOper.map(createParam);
      const createdParams = await Promise.all(paramsPromises);
      return createdParams.filter((param) => param !== null); // Filtra los nulos
    },

    async getTipoParametro(clave) {
      try {
        const response = await axios.get(
          `${API_URL}api/v1/tipo-parametros/byClave/${clave}`,
          {
            headers: {
              'Content-Type': 'application/json',
              token: this.token || localStorage.getItem('token'),
            },
          }
        );

        return response.data.response;
      } catch (error) {
        console.error(`Error al obtener tipo de parámetro ${clave}:`, error);
        return null;
      }
    },

    async createClienteParametro(body) {
      try {
        const response = await axios.post(
          `${API_URL}api/v1/clientes-parametros`,
          body,
          {
            headers: {
              'Content-Type': 'application/json',
              token: this.token || localStorage.getItem('token'),
            },
          }
        );
        return response.data.response;
      } catch (error) {
        console.error('Error al crear parámetro:', error);
        return null;
      }
    },
    async crearUsuariosClientes() {
      this.processing = true;
      this.resultadoImportacion = [];
      try {
        const clientesACrear = this.data.filter(
          (_, index) => this.checkboxStates[index]
        );

        if (clientesACrear.length <= 0) {
          return this.$swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Debe seleccionar los Legajos a importar.',
          });
        }

        const processedData = [];
        const clienteIdPorCuit = new Map();

        for (const cliente of clientesACrear) {
          let legajoId = 0;
          const cuitKey = normalizeCuit(cliente.CUIT);
          let clienteId = cliente.clienteId || clienteIdPorCuit.get(cuitKey) || null;

          // Un alta de usuario por CUIT en el lote; cada fila crea su legajo.
          if (!clienteId) {
            clienteId = await this.crearUsuario(cliente);

            if (!clienteId) {
              // manejo de error en la creación del usuario
              processedData.push({
                ...cliente,
                legajo: legajoId,
                estatus: 'Error al crear usuario',
              });
              continue;
            }
            cliente.clienteId = clienteId; // actualiza clienteId en el objeto cliente
          } else if (cliente.usuario && cliente.Email !== cliente.usuarioEmail) {
            const newEmail = cliente.Email;

            if (newEmail === '' || cliente.usuarioId === '') {
              processedData.push({
                ...cliente,
                legajo: legajoId,
                estatus: 'Error al crear usuario',
              });
              return;
            }
            //actualizo el email del cliente
            await this.updateUsuario(cliente.usuarioId, newEmail);
          }

          if (cuitKey && clienteId) {
            clienteIdPorCuit.set(cuitKey, clienteId);
            cliente.clienteId = clienteId;
          }

          const lineaId = this.operatorias.find(
            (oper) => oper.nombre === cliente.Operatoria
          );

          if (lineaId && clienteId) {
            // Verifica que existan clienteId y lineaId
            legajoId = await this.crearLegajo(
              lineaId.id,
              clienteId,
              cliente.EstadoLegajo,
              cliente.FechaDeDesembolso ? cliente.FechaDeDesembolso : ''
            );
            if (legajoId === 0) {
              // manejo de error en la creacion de legajo
              processedData.push({
                ...cliente,
                legajo: legajoId,
                estatus: 'Error al crear legajo',
              });

              continue;
            }

            await this.registrarParametros(cliente, legajoId);
          }

          processedData.push({
            ...cliente,
            legajo: legajoId,
            estatus: legajoId ? 'Success' : 'Error',
          });
        }

        this.data = processedData;
        this.resultadoImportacion = processedData;
        await this.mostrarResultadosImportacion();
        this.isValidaData = false;
        this.isOpen = false;
      } catch (error) {
        console.error('Error creando usuarios y clientes:', error);
        this.$swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Ocurrió un error durante la importación.',
        });
      } finally {
        this.processing = false;
      }
    },
    getLocalidadId(nombreLocalidad) {
      console.log('getLocalidadId', nombreLocalidad);
      if (!nombreLocalidad || !this.localidades || this.localidades.length === 0) {
        return null;
      }
      const nombreLimpiado = nombreLocalidad.toString().trim().toLowerCase();
      const localidadEncontrada = this.localidades.find(
        (l) => l.localidad.toString().trim().toLowerCase() === nombreLimpiado
      );
      return localidadEncontrada ? localidadEncontrada.id : null;
    },
    async crearUsuario(cliente) {
      cliente.usuario = this.generarUsuario(cliente);
      const localidadId = this.getLocalidadId(cliente.Localidad);
      const newUser = {
        telefono: String(cliente.Telefono1),
        username: cliente.usuario,
        email: cliente.Email,
        password: 'System@1234',
        rol: 3,
        nombre: String(cliente.Nombre) || '',
        apellido: String(cliente.Apellido) || '',
        cuit: String(cliente.CUIT),
        localidad: localidadId || '',
        razonSocial: String(cliente.RazonSocial) || '',
        sectorProductivo: 5,
        tipoCliente: String(cliente.Tipo) === 'Física' ? 1 : 0,
        sendEmail: false,
      };

      try {
        const respuesta = await axios.post(
          `${API_URL}api/v1/auth/register`,
          newUser,
          {
            headers: { 'Content-Type': 'application/json' },
          }
        );
        if (
          respuesta.data &&
          respuesta.data.cliente &&
          respuesta.data.cliente.id
        ) {
          return respuesta.data.cliente.id;
        } else {
          console.error('Error al crear usuario:', respuesta);
          return null;
        }
      } catch (error) {
        console.error('Error al crear usuario:', error);
        return null;
      }
    },

    async crearLegajo(lineaCredito_id, cliente_id, estado, FechaDeDesembolso) {
      const newLegajo = {
        lineaCredito_id,
        cliente_id,
        estado,
        fecha_desembolso: FechaDeDesembolso,
      };

      try {
        const resp = await axios.post(
          `${API_URL}api/lineaCreditoClientes`,
          newLegajo,
          {
            headers: { 'Content-Type': 'application/json', token: this.token },
          }
        );

        return (
          (resp.data &&
            resp.data.lineaCreditoCliente &&
            resp.data.lineaCreditoCliente.id) ||
          0
        );
      } catch (error) {
        console.error('Error al crear legajo:', error);
        return 0;
      }
    },

    async importar() {
      this.isLoading = true;
      const clientesACrear = this.data.filter(
        (_, index) => this.checkboxStates[index]
      );

      if (clientesACrear.length <= 0) {
        this.isLoading = false;
        return this.$swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Debe seleccionar los Legajos a importar.',
        });
      }

      const noProcesados = clientesACrear.filter((c) => c.procesado !== true);
      if (noProcesados.length > 0) {
        this.isLoading = false;
        return this.$swal.fire({
          icon: 'warning',
          title: 'Datos no procesados',
          text:
            'Hay registros seleccionados con errores de validación. Corríjalos o vuelva a procesar antes de importar.',
        });
      }

      const resumen = resumenCuitsEnFilas(clientesACrear);
      if (resumen.nClientesConVariosCreditos > 0) {
        const aviso = await this.$swal.fire({
          title: 'Varios créditos por cliente',
          html: `<div style="white-space: pre-line; text-align: left;">${this.escapeHtml(
            resumen.mensaje
          )}</div>`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Continuar',
          cancelButtonText: 'Cancelar',
        });
        if (!aviso.isConfirmed) {
          this.isLoading = false;
          return;
        }
      }

      const result = await this.$swal.fire({
        title: 'Confirmar Importación',
        html: `
          <p>¿Estás seguro de que deseas importar los legajos?</p>
          <br>
          <p style="font-size: 14px; color: #666;">
            <strong>Nota:</strong> Si el usuario ya existe, para modificar sus datos
            es necesario hacerlo desde el administrador.
          </p>
        `,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, importar',
        cancelButtonText: 'Cancelar',
      });

      if (result.isConfirmed) {
        await this.crearUsuariosClientes();
        this.isEdit = false;
        this.procesar();
      }

      this.isLoading = false;
    },
    isValidOperatoria(oper) {
      if (this.operatorias.length <= 0) {
        console.error('Error: No se pudo acceder a las operatorias');
        return false;
      }
      if (this.isOperador) {
        return this.operatorias.filter(
          (opertoria) =>
            opertoria.nombre.trim() === String(oper).trim() &&
            opertoria.fideicomiso_id === 6
        );
      }
      return this.operatorias.filter(
        (opertoria) =>
          opertoria.nombre.trim() === String(oper).trim() &&
          opertoria.fideicomiso_id !== 6
      );
    },
    async validarNroTicket(nro_ticket) {
      const url = `${API_URL}api/clienteParametros/validar/numero_ticket`;
      const header = {
        headers: {
          'Content-Type': 'application/json',
          token: this.token || localStorage.getItem('token'),
        },
      };
      const data = {
        valor: nro_ticket,
      };
      try {
        const result = await axios.post(url, data, header);
        return result.data.existe === true;
      } catch (error) {
        console.error('Error validando ticket:', error);
        return false;
      }
    },
    /**
     * Validación por fila (todos los controles), sin mutar this.errors.
     * Alineado con mdz-administracion: se acumulan varios mensajes por ítem.
     */
    getImportRowErrors(item) {
      const cliente = item.RazonSocial
        ? item.RazonSocial
        : `${item.Nombre} ${item.Apellido}`;
      const err = (field, message) => ({ cliente, field, message });
      const errors = [];

      if (!this.isValidOperatoria(item.Operatoria)) {
        errors.push(
          err('Operatoria', `Operatoria inválida: ${item.Operatoria}`)
        );
      }
      if (!isValidEstadoLegajo(item.EstadoLegajo)) {
        errors.push(err('Estado Legajo', `Operatoria : ${item.Operatoria}`));
      }
      if (!isValidTipo(item.Tipo)) {
        errors.push(
          err('Error: Tipo no válido', `Operatoria : ${item.Operatoria}`)
        );
      }
      if (!isValidCUIT(item.CUIT)) {
        errors.push(
          err('Error: CUIT no válido', `Operatoria : ${item.Operatoria}`)
        );
      }
      if (!isValidLocalidad(item.Localidad, this.localidades)) {
        errors.push(
          err('Localidad', `Localidad no válida: ${item.Localidad}`)
        );
      }
      if (!isValidSectorProductivo(item.SectorProductivo)) {
        errors.push(
          err(
            'Error: Sector productivo no válido',
            `Operatoria : ${item.Operatoria}`
          )
        );
      }
      if (!isValidEmail(item.Email)) {
        errors.push(
          err('Error: Email no válido', `Operatoria : ${item.Operatoria}`)
        );
      }
      if (!this.isOperador && !isValidGarantia(item.Garantia)) {
        errors.push(
          err('Error: Garantía no válida', `Operatoria : ${item.Operatoria}`)
        );
      }
      if (!this.isOperador && !isValidFechas(item.FechaDeInicio)) {
        errors.push(
          err('Error: Fechas Inicio no válida', `Operatoria : ${item.Operatoria}`)
        );
      }
      if (
        !this.isOperador &&
        !isValidFechasDesembolso(item.FechaDeDesembolso)
      ) {
        errors.push(
          err(
            'Error: Fecha desembolso no válida',
            `Operatoria : ${item.Operatoria}`
          )
        );
      }
      if (!this.isOperador && !isValidPagos(item.Pagos)) {
        errors.push(
          err('Error: Pagos no válidos', `Operatoria : ${item.Operatoria}`)
        );
      }
      if (!isValidCBU(item.Cbu)) {
        errors.push(
          err('Error: CBU no válido', `Operatoria : ${item.Operatoria}`)
        );
      }

      if (this.isOperador) {
        const montoANR = String(item.MontoANRAprobado || '')
          .replace('$', '')
          .replace(/\./g, '')
          .replace(',', '.');

        const inversionAprobada = String(item.InversionAprobada || '')
          .replace('$', '')
          .replace(/\./g, '')
          .replace(',', '.');
        if (isNaN(Number(montoANR)) || Number(montoANR) <= 0) {
          errors.push(
            err(
              'Error: Monto ANR Aprobado no válido',
              `Operatoria : ${item.Operatoria}`
            )
          );
        }
        if (isNaN(Number(inversionAprobada)) || Number(inversionAprobada) <= 0) {
          errors.push(
            err(
              'Error: Inversión Aprobada no válida',
              `Operatoria : ${item.Operatoria}`
            )
          );
        }
        if (errors.length === 0) {
          item.MontoANRAprobado = this.formatCurrency(Number(montoANR));
          item.InversionAprobada = this.formatCurrency(Number(inversionAprobada));
        }
      } else {
        const montoCredito = String(item.MontoDelCredito || '')
          .replace('$', '')
          .replace(/\./g, '')
          .replace(',', '.');

        if (isNaN(Number(montoCredito)) || Number(montoCredito) <= 0) {
          errors.push(
            err(
              'Error: Monto del Crédito no válido',
              `Operatoria : ${item.Operatoria}`
            )
          );
        } else {
          item.MontoDelCredito = this.formatCurrency(Number(montoCredito));
        }
      }

      return errors;
    },
    isValidItem(item) {
      const errs = this.getImportRowErrors(item);
      errs.forEach((e) => this.errors.push(e));
      return errs.length === 0;
    },
    limpiarTabla() {
      this.data = [];
      this.errors = [];
      this.editData = [];
      this.archivo = null;
      this.isValidFile = false;
      this.isValidaData = false;
      this.isEdit = true;
      this.$router.go(0);
    },
    showEditModal(index) {
      this.editData = this.data[index] ? this.data[index] : [];
      this.isOpen = true;
    },
    isValidEmail(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    },

    /** CUIT como string solo dígitos, p. ej. "20285893152" (JSON /api/v1/clientes/search). */
    cuitStringForApi(value) {
      if (value == null || value === '') return '';
      return String(value).replace(/\D/g, '');
    },

    getClass(item) {
      if (item.usuario) {
        return 'green-water';
      } else if (item.usuario) {
        return 'light-red';
      } else {
        return ''; // Sin estilo si username está vacío
      }
    },
    mostrarErrores() {
      if (this.errors.length > 0) {
        this.isLoading = false;
        this.processing = false;
        this.$swal.fire({
          icon: 'error',
          title: 'Error',
          html: this.errors
            .map((error) => {
              const clienteMessage = error.cliente
                ? `Cliente: ${error.cliente}, `
                : '';
              return `<p>${clienteMessage}${error.field}: ${error.message}</p>`;
            })
            .join(''),
        });
        this.errors = []; // Limpia los errores después de mostrarlos
      }
    },
    async procesar() {
      this.processing = true;
      this.isLoading = true;
      this.errors = [];
      this.isProccess = true;

      const cuits = this.data
        .map((item) => this.cuitStringForApi(item.CUIT))
        .filter(function (c) {
          return c.length > 0;
        });
      const dataToSend = { cuits };

      try {
        const response = await axios.post(
          `${API_URL}api/v1/clientes/search`,
          dataToSend,
          {
            headers: {
              'Content-Type': 'application/json',
              token: this.token || localStorage.getItem('token'),
            },
          }
        );

        const usuarios =
          response.data && response.data.response != null
            ? response.data.response
            : [];

        const processedData = [];
        const clientesPorCuit = new Map();

        for (const excel of this.data) {
          const cuitKey = this.cuitStringForApi(excel.CUIT);
          const clienteResuelto = resolverClientePorCuit(
            cuitKey || excel.CUIT,
            clientesPorCuit,
            usuarios
          );
          const userEmail = clienteResuelto.usuarioEmail;
          const username = clienteResuelto.usuario;
          const clienteId = clienteResuelto.clienteId;
          const usuarioId = clienteResuelto.usuarioId;

          const cliente = excel.RazonSocial
            ? excel.RazonSocial
            : `${excel.Nombre} ${excel.Apellido}`;

          // Solo antes de importar: validar unicidad del ticket vía API.
          // Tras importar, isEdit es false: el ticket ya está en BD; no llamar validar/numero_ticket.
          if (this.isOperador && excel.Ticket) {
            const ticket = excel.Ticket;
            if (
              (typeof ticket === 'string' && ticket.trim() === '') ||
              ticket == null
            ) {
              this.errors.push({
                cliente,
                field: 'Error: Ticket no válido',
                message: `Operatoria: ${excel.Operatoria}`,
              });
              continue;
            }

            if (this.isEdit) {
              const ticketExiste = await this.validarNroTicket(ticket);
              if (ticketExiste) {
                this.errors.push({
                  cliente,
                  field: 'Error: Ticket ya existe',
                  message: `Operatoria: ${excel.Operatoria}`,
                });
                continue;
              }
            }
          }

          const row = { ...excel, CUIT: cuitKey || excel.CUIT };
          const itemErrors = this.getImportRowErrors(row);
          const observaciones =
            itemErrors.length === 0
              ? ''
              : itemErrors.map((e) => `${e.field}: ${e.message}`).join('; ');

          processedData.push({
            ...row,
            clienteId,
            usuarioEmail: userEmail,
            usuarioId,
            usuario: username,
            procesado: itemErrors.length === 0,
            Observaciones: observaciones,
          });
        }

        if (this.errors.length > 0) {
          this.mostrarErrores();
          return;
        }

        const validItems = processedData.filter((r) => r.procesado).length;
        const invalidItems = processedData.length - validItems;

        this.data = processedData;
        this.checkboxStates = this.data.map(() => false);
        this.selectAllBox = false;

        if (invalidItems > 0) {
          this.isValidaData = false;
          await this.$swal.fire({
            icon: 'warning',
            title: 'Validación completada',
            html: `<p>${validItems} registro(s) válido(s), ${invalidItems} con errores.</p><p>Corrija los datos o la columna <strong>Observaciones</strong> antes de importar.</p>`,
          });
        } else {
          this.isValidaData = true;
          showSimpleMessage('Success', 'Legajos procesados', 'success', 2000);
        }

        this.isOpen = false;
      } catch (error) {
        console.error('Error en procesamiento:', error);
        await this.$swal.fire({
          icon: 'error',
          title: 'Error de procesamiento',
          text: 'No se pudieron validar los datos (por ejemplo, búsqueda de clientes).',
        });
      } finally {
        this.processing = false;
        this.isLoading = false;
        this.isProccess = false;
      }
    },
    updateData(newData) {
      this.data.splice(this.editIndex, 1, newData);
    },
    validateFile() {
      if (this.archivo) {
        const file = this.archivo;
        const fileExtension = file.name.split('.').pop().toLowerCase();
        this.isValidFile = fileExtension === 'xlsx';
      } else {
        this.isValidFile = false;
      }
    },

    handleFileSelected(event) {
      this.archivo = event.target.files[0];
      this.isValidFile =
        this.archivo &&
        this.archivo.type ===
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    },
    parseDateString(dateString) {
      if (!dateString) return null; //Maneja casos nulos o vacíos
      const [day, month, year] = dateString.split('/').map(Number);

      //Validación básica:
      if (
        isNaN(day) ||
        isNaN(month) ||
        isNaN(year) ||
        day < 1 ||
        day > 31 ||
        month < 1 ||
        month > 12 ||
        year < 1900
      ) {
        return 'Fecha Inválida';
      }

      const formattedDate = `${day.toString().padStart(2, '0')}/${month
        .toString()
        .padStart(2, '0')}/${year}`;
      return formattedDate;
    },
    async uploadFile() {
      this.loadingCarga = true;
      const reader = new FileReader();
      const colsName = [
        'Legajo',
        'Operatoria',
        'Estado de legajo',
        'Tipo',
        'Nombre',
        'Apellido',
        'Razón Social',
        'Número de DNI',
        'Número de CUIT',
        'Localidad',
        'Teléfono 1',
        'Teléfono 2',
        'Sector productivo',
        'mail',
        ...(this.isOperador
          ? ['Monto ANR Aprobado', 'Inversion Aprobada', 'Ticket']
          : [
              'Monto de crédito',
              'Fecha de desembolso',
              'Fecha de inicio',
              'Plazo de de crédito',
              'Plazo de gracia',
              'Pagos',
              'Garantía',
            ]),
        'CBU',
      ];

      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = xlsx.read(data, { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];

        const columnNames = [];

        const range = worksheet['!ref'].split(':');
        const startCol = range[0].replace(/\d/g, '');
        const endCol = range[1].replace(/\d/g, '');

        for (
          let col = startCol.charCodeAt(0);
          col <= endCol.charCodeAt(0);
          col++
        ) {
          const cellAddress = String.fromCharCode(col) + '1';
          if (worksheet[cellAddress]) {
            columnNames.push(worksheet[cellAddress].v);
          }
        }

        const unexpectedColumns = [];
        for (const colName of colsName) {
          if (!columnNames.includes(colName)) {
            unexpectedColumns.push(colName);
          }
        }

        if (unexpectedColumns.length > 0) {
          this.loadingCarga = false;
          this.$swal.fire({
            icon: 'error',
            title: 'Error',
            text: `No se encontró la(s) columna(s) ${unexpectedColumns.join(
              ', '
            )}. Por favor revise el archivo Excel. El nombre debe coincidir`,
          });
          this.loadingCarga = false;

          return;
        }
        const jsonData = xlsx.utils.sheet_to_json(worksheet, {
          cellDates: true,
          raw: false,
        });
        if (jsonData.length === 0) {
          this.$swal.fire({
            icon: 'warning',
            title: 'Advertencia',
            text: 'El archivo está vacío o no contiene datos. Por favor, seleccione un archivo con información.',
          });
          this.loadingCarga = false;
          return;
        }
    
        const dataWithAddedColumns = jsonData
          .map((item) => ({
            Operatoria:
              typeof item.Operatoria === 'string' ? item.Operatoria.trim() : '',
            EstadoLegajo:
              typeof item['Estado de legajo'] === 'string'
                ? item['Estado de legajo'].trim()
                : '',
            Tipo: typeof item.Tipo === 'string' ? item.Tipo.trim() : '', //Añadido para Tipo
            Nombre: typeof item.Nombre === 'string' ? item.Nombre.trim() : '', //Añadido para Nombre
            Apellido:
              typeof item.Apellido === 'string' ? item.Apellido.trim() : '', //Añadido para Apellido
            RazonSocial:
              typeof item['Razón Social'] === 'string'
                ? item['Razón Social'].trim()
                : '', //Añadido para RazonSocial
            DNI:
              typeof item['Número de DNI'] === 'string'
                ? item['Número de DNI'].trim()
                : '', //Añadido para DNI
            CUIT:
              typeof item['Número de CUIT'] === 'string'
                ? item['Número de CUIT'].trim()
                : '', //Añadido para CUIT
                Localidad:
              typeof item['Localidad'] === 'string' ? item.Localidad.trim() : '',
            Telefono1:
              typeof item['Teléfono 1'] === 'string'
                ? item['Teléfono 1'].trim()
                : '', //Añadido para Telefono1
            Telefono2:
              typeof item['Teléfono 2'] === 'string'
                ? item['Teléfono 2'].trim()
                : '', //Añadido para Telefono2
            SectorProductivo:
              typeof item['Sector productivo'] === 'string'
                ? item['Sector productivo'].trim()
                : '', //Añadido para SectorProductivo
            Email: typeof item.mail === 'string' ? item.mail.trim() : '', //Añadido para Email
            Cbu: item.CBU,
            ...(this.isOperador
              ? {
                  MontoANRAprobado: item['Monto ANR Aprobado'],
                  InversionAprobada: item['Inversion Aprobada'],
                  Ticket: item.Ticket,
                }
              : {
                  MontoDelCredito: item['Monto de crédito'],
                  FechaDeDesembolso: item['Fecha de desembolso']
                    ? this.parseDateString(item['Fecha de desembolso'])
                    : null, // o una fecha por defecto
                  FechaDeInicio: item['Fecha de inicio']
                    ? this.parseDateString(item['Fecha de inicio'])
                    : null, // o una fecha por defecto
                  PlazoDeCredito: item['Plazo de de crédito'],
                  PlazoDeGracia: item['Plazo de gracia'],
                  Pagos: item.Pagos,
                  Garantia:
                    typeof item.Garantía === 'string'
                      ? item.Garantía.trim()
                      : item.Garantía,
                }),
          }));

        this.errors = [];
        for (const item of dataWithAddedColumns) {
          const errs = this.getImportRowErrors(item);
          errs.forEach((e) => this.errors.push(e));
        }

        if (this.errors.length > 0) {
          this.loadingCarga = false;
          this.$swal
            .fire({
              icon: 'error',
              title: 'Error',
              html: this.errors
                .map((error) => {
                  const clienteMessage = error.cliente
                    ? `Cliente: ${error.cliente}, `
                    : '';
                  return `<p>${clienteMessage}${error.field}: ${error.message}</p>`;
                })
                .join(''),
              //Añadido showConfirmButton para que se muestre el botón OK
              showConfirmButton: true,
            })
            .then((result) => {
              if (result.isConfirmed) {
                this.$router.go(0);
              }
              this.processing = false;
              this.errors = [];
            });
          return;
        }

        this.data = dataWithAddedColumns;
        this.isValidaData = false;
        this.checkboxStates = this.data.map(() => false);
        this.selectAllBox = false;

        this.loadingCarga = false;
      };
      reader.onerror = (error) => {
        this.loadingCarga = false;
        this.$swal.fire({
          icon: 'error',
          title: 'Error al leer el archivo',
          text: 'Ocurrió un error al leer el archivo seleccionado. Por favor, intenta de nuevo con un archivo válido.',
        });
        console.error('Error al leer el archivo:', error);
      };
      reader.readAsArrayBuffer(this.archivo);
    },
     async buscarLocalidades() {
      const url = `${API_URL}api/v1/localidades`;

      const header = {
        headers: {
          'Content-Type': 'application/json',
          token: this.token,
        },
      };
      axios
        .get(url, header)
        .then((response) => {
          
          if (response.data.status==='success') {
            this.localidades = response.data.response.map((res) => ({
              id: res.id,
              localidad: res.nombre,
            }));
            
          }
        })

        .catch((error) => {
          console.error(`Error al buscar localidades: ${error}`);
        });
    },
    async buscarOperatorias() {
      const url = `${API_URL}api/v1/lineas-creditos`;

      const header = {
        headers: {
          'Content-Type': 'application/json',
          token: this.token,
        },
      };
      axios
        .get(url, header)
        .then((response) => {
          if (response.data.status === 'success') {
            this.operatorias = response.data.response;
          }
        })

        .catch((error) => {
          console.error(`Error al buscar operatorias: ${error}`);
        });
    },
    getListaSolicitudEstado() {
      const url = `${API_URL}api/solicitudEstado`;
      const header = {
        headers: {
          'Content-Type': 'application/json',
          token: this.token,
        },
      };
      axios.get(url, header).then((response) => {
        this.estadosSolicitud = response.data.solicitudEstado;
      });
    },
  },

  async created() {
    this.checkboxStates = this.data.map(() => false); // Inicializa los estados de los checkboxes

    this.buscarOperatorias();
     this.buscarLocalidades();
    this.getListaSolicitudEstado();

    const rolId = parseInt(localStorage.getItem('rol'), 10);
    this.tipoRol = rolId;
    this.isOperador = rolId === 2;
  },
};
</script>
<style scoped>
.green-water {
  background-color: rgb(220, 252, 252); /* O cualquier otro color verde agua */
}
.light-red {
  background-color: rgb(250, 205, 205);
}
.swal-modal {
  width: 800px; /* Aumenta el ancho del modal */
  height: 500px; /* Aumenta la altura del modal */
}

.swal-title {
  font-size: 18px; /* Aumenta el tamaño del título */
  font-weight: bold;
}

.swal-text {
  font-size: 14px; /* Aumenta el tamaño del texto */
}
</style>